import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TextDialogData } from '@app/shared/models/dialog-data';
import { InfoDialogComponent } from '@app/shared/dialogs/info-dialog/info-dialog.component';


@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent extends InfoDialogComponent {

  constructor(public dialogRef: MatDialogRef<ConfirmModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: TextDialogData) {
    super(dialogRef, data);
    this._idPrefix = 'confirm_dialog.';
  }

  public accept(): void {
    this.dialogRef.close(true);
  }

}
